<template>
  <v-container>
    <template>
      <div class="d-flex align-center mb-2">
        <span class="font-weight-bold">Remit Units</span>
        <v-btn class="input-text-size" text color="blue darken-1"
         @click="validateRecords">Validate Records</v-btn>
        <v-btn class="input-text-size ml-auto" text color="blue darken-1"
        @click="printRemitUnits">Print Remit Units</v-btn>
      </div>
      <CRUDList
        ref="crudList"
        :canAdd="canAddToSharedList"
        :canEdit="true"
        :canSave="canEditSharedList"
        :showSelect="false"
        :enableFixedHeaders="true"
        :headers="headers"
        :displayTopPagination="false"
        :baseCrudKey="baseCrudKey"
        :dialogHeaderName="dialogHeaderName"
        :defaultSortBy="defaultSortBy"
        :tableTitle="dialogHeaderName"
        dialogDynamicWidth="40vw"
        @loadCRUDList="handleLoadRemitUnitsList"
        @upsertItem="upsertRecords"
        @deleteItem="deleteFromDiaglog"
        tableWrapperDynamicClassname='elevation-3 mt-4 ma-3 pt-0 pa-1 taxroll-table-wrapper'
        tableDynamicClassname='taxroll-custom-table'
        tableDynamicHeight='400'
        :loadingData="gridLoading.flag"
        :loadingText="gridLoading.text"
        >
        <template v-slot:[`editedItem`]="{ }">
          <remitUnitEditedItem  :baseCrudKey="baseCrudKey"/>
        </template>
      </CRUDList>
      <v-dialog v-model="validationDialog" max-width="600px">
        <v-card>
          <v-card-title class="headline">Validation Results</v-card-title>
          <v-card-text>
            <div
              v-if="validationResult
              && validationResult.isValid === 'true'"
              class="text-success">
                All records are valid.
            </div>
            <div v-else-if="validationResult
              && validationResult.messages
              && validationResult.messages.length"
            >
              <div v-for="(msg, idx) in validationResult.messages" :key="idx" class="mb-2">
                <span class="font-weight-bold" style="color: black;">Error:</span>
                <span style="color: red; white-space: pre-line;">
                  {{ formatValidationMessage(msg) }}
                </span>
              </div>
            </div>
            <div v-else>No validation results.</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="validationDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isRequiredToShowErrorDialog" max-width="600px">
        <v-card>
          <v-card-text class="pt-4">
            <v-alert type="error" outlined>
              <strong>Validation Errors</strong>
            </v-alert>
            <div v-if="validationErrorData.length">
              <h4>
                Record Details ({{ currentErrorIndex + 1 }} of {{ validationErrorData.length }}):
              </h4>
              <v-simple-table dense>
                <tbody>
                  <tr>
                    {{ validationErrorData[currentErrorIndex].message }}
                  </tr>
                  <tr>
                    <td class="error--text"
                      v-html="Array.isArray(validationErrorData[currentErrorIndex].values)
                        ? validationErrorData[currentErrorIndex].values.join('<br>')
                        : (typeof validationErrorData[currentErrorIndex].values === 'string'
                          ? validationErrorData[currentErrorIndex].values
                            .replace(/\n/g, '<br>')
                            .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
                          : validationErrorData[currentErrorIndex].values)"
                    ></td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="currentErrorIndex < validationErrorData.length - 1"
              color="primary"
              text
              @click="showNextError"
            >
              <v-icon left>mdi-arrow-right</v-icon>
              Continue ({{ currentErrorIndex + 1 }}/{{ validationErrorData.length }})
            </v-btn>
            <v-btn
              v-else
              color="primary"
              text
              disabled
            >
              <v-icon left>mdi-check</v-icon>
              Continue
            </v-btn>
            <v-btn color="error" text @click="hideErrorWindow">
              <v-icon left>mdi-close</v-icon>
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import { RemitUnitHeaders } from '../Utils/taxHeaders.utils';
import remitUnitEditedItem from './remitUnitEditedItem.vue';
import '../../../assets/style.css';
import { defaultGridLoading, manageGridLoading } from '../../../util/shared/vue-global';
import SharedListAccessControlMixin from '../SharedListAccessControl.mixin';
import { generateQueryString } from '../../common/base/report/report-util';
import { clients } from '../../../util/clients/index';

const { backendRest } = clients.direct;
export default {
  name: 'remitUnitList',
  mixins: [SharedListAccessControlMixin],
  components: {
    CRUDList,
    remitUnitEditedItem,
  },
  data() {
    return {
      selectedRows: [],
      baseCrudKey: 'remitUnitSharedList',
      selectedRow: null,
      dialogHeaderName: 'Remit Units',
      headers: RemitUnitHeaders,
      gridLoading: defaultGridLoading(),
      validationDialog: false,
      validationResult: null,
      isRequiredToShowErrorDialog: false,
      validationErrorData: [],
      currentErrorIndex: 0,
    };
  },
  created() {
    // this.getTaxStatusCodesSharedRecords();
    this.criteriaState = {};
  },
  destroyed() {
  },
  computed: {
    ...mapGetters('base/crud', ['criteria']),
    ...mapState({
      StoreSelItems: (state) => state.shared.remitUnit.selectedItems,
    }),
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'fees',
          direction: 'desc',
        },
      ];
    },
  },
  methods: {
    manageGridLoading,
    ...mapActions(['reAuth', 'flashError']),
    ...mapMutations('base/crud', ['setCriteria']),
    ...mapMutations('shared/remitUnit', [
      'setSelectedItems',
    ]),
    ...mapActions('shared/remitUnit', [
      'loadremitUnitRecords',
      'upsertRemitUnit',
      'deleteRemitUnit',
      'validateRemitUnit',
    ]),
    ...mapActions(['flashInfo', 'flashWarn', 'flashError', 'flashSuccess']),

    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async upsertRecords(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      await this.upsertRemitUnit({ item: updatedItem, baseCrudKey });
    },
    deleteFromDiaglog(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deleteRemitUnit({ item, baseCrudKey });
      }
    },
    handleLoadRemitUnitsList() {
      const { baseCrudKey } = this;
      const criteria = { ...this.criteriaState };
      manageGridLoading(this, true, 'Searching...');
      this.loadremitUnitRecords({ baseCrudKey, criteria }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    async validateRecords() {
      if (window.confirm('Are you sure you want to validate these items?')) {
        try {
          const validationResult = await this.validateRemitUnit();
          if (validationResult && validationResult.isValid === 'false') {
            this.validationErrorData = validationResult.messages || [];
            this.currentErrorIndex = 0;
            this.isRequiredToShowErrorDialog = true;
          } else {
            this.flashSuccess('All records are valid!');
          }
        } catch (e) {
          alert(`Validation failed:  ${e.message || e}`);
        }
      }
    },
    async printRemitUnits() {
      const { jwt } = await this.reAuth();
      let sortBy = 'additionCode';
      let direction = 'asc';

      if ((this.criteriaState || {}).sortBy.length) {
        sortBy = this.criteriaState.sortBy[0].column;
        direction = this.criteriaState.sortBy[0].direction;
      }
      const params = [
        `token=${jwt}`,
        `sortBy=${sortBy || ''}`,
        `direction=${direction || ''}`,
      ];
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/shared/remit-units-report${queryString}`;
      window.open(url, '_blank');
    },
    showNextError() {
      if (this.currentErrorIndex < this.validationErrorData.length - 1) {
        this.currentErrorIndex += 1;
      }
    },
    hideErrorWindow() {
      this.currentErrorIndex = 0;
      this.validationErrorData = [];
      this.isRequiredToShowErrorDialog = false;
      this.handleLoadRemitUnitsList();
    },
    formatValidationMessage(msg) {
      if (!msg) return '';
      if (typeof msg === 'string') return msg;
      if (msg.message && msg.values) {
        let formatted = msg.message;
        Object.keys(msg.values).forEach((key) => {
          formatted = formatted.replace(new RegExp(`{${key}}`, 'g'), msg.values[key]);
        });
        return formatted;
      }
      if (msg.message) return msg.message;
      return JSON.stringify(msg);
    },
  },
};
</script>
